import { jsx as _jsx } from "react/jsx-runtime";
import { PresenceBadge } from "@fluentui/react-components";
import { PropertyLine } from "./propertyLine";
/**
 * Displays an icon indicating enabled (green check) or disabled (red cross) state
 * @param props - The properties for the PropertyLine, including the boolean value to display.
 * @returns A PropertyLine component with a PresenceBadge indicating the boolean state.
 */
export const BooleanBadgePropertyLine = (props) => {
    BooleanBadgePropertyLine.displayName = "BooleanBadgePropertyLine";
    // For now assume BooleanBadge is used for readonly properties and disable copy. In future we could enable with a different copy string
    return (_jsx(PropertyLine, { ...props, onCopy: undefined, children: _jsx(PresenceBadge, { status: props.value ? "available" : "do-not-disturb", outOfOffice: true }) }));
};
//# sourceMappingURL=booleanBadgePropertyLine.js.map